/**
 * Notification Service — read/update notifications for the current borrower.
 */

import { apiClient } from './api-client';

export interface Notification {
  id: string;
  type: 'message' | 'task' | 'milestone' | 'document' | 'system';
  title: string;
  body: string;
  createdAt: string;
  read: boolean;
  dismissible: boolean;
  actionUrl?: string;
  actionLabel?: string;
}

export interface NotificationsResult {
  notifications: Notification[];
  unreadCount: number;
}

export const notificationService = {
  /** Fetch notifications for the current borrower */
  getNotifications(): Promise<NotificationsResult> {
    return apiClient.get<NotificationsResult>('/api/v1/notifications');
  },

  /** Mark a single notification as read */
  markAsRead(notificationId: string): Promise<void> {
    return apiClient.patch(`/api/v1/notifications/${notificationId}/read`, {});
  },

  /** Mark all notifications as read */
  markAllRead(): Promise<void> {
    return apiClient.post('/api/v1/notifications/mark-all-read', {});
  },

  /** Dismiss a notification */
  dismiss(notificationId: string): Promise<void> {
    return apiClient.delete(`/api/v1/notifications/${notificationId}`);
  },
};
